// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Feeds {
  /* width: 55%;
  color: white;
  padding-top: 15vh;
  margin-left: 22%;
  position: relative;
  z-index: 1; */
}

/* Ballot Search & Political Affiliation Filter Bar */
.ballotSearchBarContainer {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: #142222;
  border-radius: 12px;
  border: 1px solid #233737;
  margin: 12px 0 6px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.ballotSearchInputWrap {
  flex: 1 1;
  display: flex;
  align-items: center;
  background: #0e1b1b;
  border: 1px solid #2a3d3d;
  border-radius: 20px;
  padding: 6px 14px;
  gap: 8px;
  transition: all 0.2s ease;
}

.ballotSearchInputWrap:focus-within {
  border-color: #5aaf9a;
  box-shadow: 0 0 0 2px rgba(90, 175, 154, 0.2);
}

.ballotSearchInputField {
  flex: 1 1;
  background: transparent;
  border: none;
  outline: none;
  color: #ffffff;
  font-size: 14px;
  font-family: inherit;
}

.ballotSearchInputField::placeholder {
  color: #728a8a;
  font-size: 13.5px;
}

.ballotClearSearchBtn {
  background: transparent;
  border: none;
  color: #728a8a;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 2px;
  border-radius: 50%;
  transition: color 0.15s ease;
}

.ballotClearSearchBtn:hover {
  color: #ffffff;
}

.ballotSearchResultsInfo {
  padding: 4px 16px 8px 16px;
  color: #8fa8a8;
  font-size: 13px;
}

.ballotSearchResultsInfo strong {
  color: #5aaf9a;
}

@media (max-width: 768px) {
  .ballotSearchBarContainer {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    padding: 10px 12px;
  }

  .ballotPartyFilterBtn {
    width: 100%;
    justify-content: space-between;
  }

  .ballotPartyDropdownMenu {
    left: 0;
    right: auto;
    width: 100%;
  }

  .partyBtnLabel {
    max-width: none;
  }
}

.feedsContainer {
  /* display: flex;
  flex-direction: column;
  justify-content: stretch;
  width: 100%; */
}

/* .feedCardContainer {
  width: 85%;
} */

.feedCard {
  background-color: #0e1b1b;
  display: flex;
  justify-content: center;
  border-radius: 20px;
  margin-top: 2vh;
  transform: 0.3s;
}

.feedBody {
  width: 90%;
  box-sizing: border-box;
  padding-top: 2vh;
  padding-bottom: 2vh;
}

.feedCardHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.profileDetailsContainer {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 0.5vw;
}

.profilePic {
  height: 50px;
  width: 50px;
  border-radius: 50px;
}

.profileDetails {
  display: flex;
  flex-direction: column;
  justify-content: start;
}

.profileNameText {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  /* Add text wrapping properties */
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
}

.timeContainer {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 0.8vw;
}

.timeText {
  color: var(--Grey, #777);
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.infoIcon {
  height: 24px;
  width: 24px;
  cursor: pointer;
}

.infoIcon:hover {
  transform: scale(1.1);
  transition: all 0.3s ease;
}

.feedCardVoteTitleContainer {
  margin-top: 1.2vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.voteTitleText {
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 10px;
  /* Add text wrapping properties */
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
}


.voteMediaContainer {
  margin-top: 30px;
  height: 60vh;
  background-color: #070F0F;
  border-radius: 15px;
}

.voteMedia {
  height: 100%;
  width: 100%;
  border-radius: 12px;
  object-fit: contain;
}

.voteDescriptionContainer {
  margin-top: 30px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #777;
  /* Add text wrapping properties */
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
}

.voteDescriptionText {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #777;
  /* Add text wrapping properties */
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
  display: block;
  width: 100%;
}

.voteBtnsContainer {
  display: flex;
  margin-top: 20px;
  flex-direction: column;
  width: 100%;
  gap: 10px;
}

.voteBtn {
  all: unset;
  border-radius: 12px;
  border: 1px solid #484848;
  box-sizing: border-box;
  padding-top: 2vh;
  padding-bottom: 2vh;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.voteBtncoloured {
  all: unset;
  border-radius: 12px;
  border: 1px solid #484848;
  box-sizing: border-box;
  padding-top: 2vh;
  padding-bottom: 2vh;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  background-color: #3BB3AE;
}

.voteDetailsContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 2vh;
}

.voteActionContainer {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 18px;
}

.voteActionContainer2 {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 6px;
  cursor: pointer;
}

.feedCardFooterText {
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.feedCardFooterIcon {
  height: 28px;
  width: 28px;
}

.like-icon:hover {
  transform: scale(1.2);
  transition: all 0.3s ease;
}

.pdfContainer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #070F0F;
  border-radius: 8px;
  overflow: hidden;
  min-height: 400px;
}

.pdf-loading,
.pdf-error {
  color: white;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  padding: 20px;
  text-align: center;
}

.pdf-error {
  color: #ff6b6b;
}

.pdfContainer .react-pdf__Document {
  width: 100%;
  display: flex;
  justify-content: center;
}

.pdfContainer .react-pdf__Page {
  max-width: 100%;
  height: auto;
}

.pdfLinkContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-radius: 12px;
}

.pdfLink {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 50px;
  background: #48D1CC;
  color: #070F0F;
  text-decoration: none;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.pdfLink:hover {
  background: #3BB3AE;
  transform: translateY(-2px);
}

.pdfIcon {
  width: 24px;
  height: 24px;
}

.vote-button-wrapper {
  position: relative;
  width: 100%;
  padding: 20px 20px;
  margin: 8px 0;
  border: 0.2px solid #484848;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
}

.vote-button-wrapper:disabled {
  cursor: default;
  opacity: 0.9;
}

.vote-button-wrapper:not(:disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.vote-progress-bar {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: #3BB3AE;
  transition: width 0.6s ease-in-out;
  z-index: 1;
  width: 0;
}

.vote-text {
  position: relative;
  z-index: 2;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: white;
  /* Add text wrapping properties */
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
  text-align: left;
}

.vote-text.voted {
  color: #777;
}

.vote-percentage.voted {
  color: #777;
}

.vote-percentage {
  position: relative;
  z-index: 2;
  font-size: 14px;
  font-weight: 600;
  color: white;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.voted .vote-percentage {
  opacity: 1;
}

.voted .vote-progress-bar {
  background-color: #3BB3AE;
}

.voted.selected .vote-progress-bar {
  background-color: #3BB3AE;
  opacity: 1;
  animation: progressFill 0.8s ease-out;
}

@keyframes progressFill {
  from {
    width: 0;
  }

  to {
    width: 100%;
  }
}

.vote-button-wrapper:hover .vote-percentage {
  opacity: 1;
}

/* Remove previous button styles if they exist */
.voteBtn,
.voteBtncoloured {
  display: none;
}

.commentContainer {
  margin-top: 20px;
  padding: 15px;
  border-top: 1px solid #484848;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.commentInputContainer {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  background: transparent;
  border-radius: 8px;
  height: 17vh;
}

.feedsCommentInput {
  all: unset;
  width: 100%;
  height: 100%;
  background: #070F0F;
  border: 1px solid #484848;
  border-radius: 8px;
  padding-top: 15px;
  padding-left: 15px;
  padding-right: 6.5vw;
  color: white;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  resize: none;
  outline: none;
  box-sizing: border-box;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
}

.commentInput:focus {
  border-color: #3BB3AE;
}

.filePreviewContainer {
  position: relative;
  width: 100%;
  height: 90%;
  border-radius: 8px;
  overflow: hidden;
  background: #070F0F;
  border: 1px solid #484848;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 15px;
  padding-bottom: 15px;
  z-index: 1;
}

.filePreview {
  max-width: 100%;
  max-height: 90%;
  width: auto;
  height: auto;
  object-fit: contain;
  background: rgba(255, 255, 255, 0.10);
  padding: 15px 30px;
  border-radius: 12px;
}

.commentButtonContainer {
  position: absolute;
  right: 2%;
  top: 10%;
  display: flex;
  gap: 5px;
  z-index: 2000;
}

.commentButton {
  background: #3BB3AE;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 2000;
}

.commentButton:hover {
  background: #48D1CC;
  transform: translateY(-2px);
}

.clearFileBtn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: background-color 0.2s;
}

.clearFileBtn:hover {
  background: rgba(0, 0, 0, 0.9);
}

.existingCommentsContainer {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.commentItem {
  display: flex;
  /* flex-direction: row; */
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 10px;
  border-radius: 8px;
  /* background: #070F0F; */
  border: 1px solid #484848;
  height: auto;
}

.commentItemContainer {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.commentHeader {
  display: flex;
  align-items: center;
  gap: 10px;
}

.commentUserPhoto {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.commentUserInfo {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.commentUserName {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: white;
  /* Add text wrapping properties */
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
}

.commentTime {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #777;
}

.commentText {
  font-family: "Inter", sans-serif;
  font-size: 18px;
  color: white;
  line-height: 1.4;
  padding-left: 42px;
  /* Add text wrapping properties */
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
}

.popupOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.popupContent {
  position: absolute;
  background-color: #071414;
  padding: 15px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popupBtn {
  border: 1px solid #484848;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 500;
  font-family: "Inter", sans-serif;
  width: 100%;
  display: flex;
  width: 349.407px;
  height: 57px;
  padding: 20px;
  justify-content: start;
  gap: 10px;
  color: #FFF;
  font-size: 15px;
  font-style: normal;
  background-color: #071414;
  align-items: center;
}

.popupTitle {
  color: #FFF;
  text-overflow: ellipsis;
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.commentVideo {
  width: 100%;
  height: 20vh;
  object-fit: contain;
  border-radius: 12px;
}

.saveBtn:hover {
  background-color: #484848;
}


.reportBtn:hover {
  background-color: #484848;
}

.deleteCommentBtn {
  background-color: transparent;
  border: none;
}

.shareButtonsContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0;
}

.voteShareContainer {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.voteShareContainer:hover {
  transform: scale(1.1);
}

.informationBtnIcon {
  height: 24px;
  width: 24px;
}

.informationBtnText {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
}

.reportBtnText {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  color: #C15F5F;
}

.reportReasonContainer {
  margin-top: 10px;
}

.reportReasonOptions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}

.reportReasonOption {
  border: 1px solid #484848;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 500;
  font-family: "Inter", sans-serif;
  width: 100%;
  display: flex;
  width: 310px;
  height: 10px;
  padding: 20px;
  justify-content: start;
  gap: 10px;
  color: #FFF;
  font-size: 15px;
  font-style: normal;
  background-color: #071414;
  display: flex;
  align-items: center;
}

.reportReasonOption:hover {
  background-color: #484848;
}

.pausedContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 5px;
  background-color: #484848;
}

.pausedtext {
  color: #5AAF9A;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

@media (max-width: 1640px) {
  .profilePic {
    height: 45px;
    width: 45px;
  }

  .profileNameText {
    font-size: 15px;
  }

  .timeText {
    font-size: 15px;
  }

  .infoIcon {
    height: 22px;
    width: 22px;
  }

  .voteTitleText {
    font-size: 18px;
  }

  .pdfLink {
    gap: 10px;
    padding: 12px 45px;
    border-radius: 8px;
    font-size: 16px;
  }

  .voteDescriptionContainer {
    margin-top: 30px;
    font-size: 16px;
  }

  .voteDescriptionText {
    font-size: 16px;
  }

  .vote-button-wrapper {
    padding: 18px;
    margin: 8px 0;
    border-radius: 8px;
  }

  .vote-text {
    font-size: 18px;
  }

  .vote-percentage {
    font-size: 14px;
  }

  .voteActionContainer {
    gap: 16px;
  }

  .feedCardFooterText {
    font-size: 18px;
  }

  .feedsCommentInput {
    padding-top: 14px;
    padding-left: 14px;
    font-size: 14px;
  }

  .commentButton {
    padding: 7px;
  }

  .commentUserPhoto {
    width: 30px;
    height: 30px;
  }

  .commentUserName {
    font-size: 13px;
  }

  .commentTime {
    font-size: 12px;
  }

  .commentText {
    font-size: 14px;
  }

  .popupContent {
    padding: 14px;
    gap: 9px;
    border-radius: 20px;
  }

  .popupBtn {
    border-radius: 12px;
    width: 320px;
    height: 54px;
    padding: 18px;
    gap: 8px;
    font-size: 14px;
  }

  .informationBtnIcon {
    height: 22px;
    width: 22px;
  }

  .informationBtnText {
    font-size: 15px;
  }

  .reportBtnText {
    font-size: 15px;
  }

  .reportReasonOptions {
    gap: 9px;
    margin-top: 9px;
  }

  .reportReasonOption {
    font-size: 15px;
    border-radius: 12px;
    width: 300px;
    height: 8px;
    padding: 18px;
  }

  .pausedContainer {
    padding: 4px 9px;
    border-radius: 5px;
  }

  .pausedtext {
    font-size: 11px;
  }
}

@media (max-width: 1440px) {
  .profilePic {
    height: 40px;
    width: 40px;
  }

  .profileNameText {
    font-size: 14px;
  }

  .timeText {
    font-size: 14px;
  }

  .infoIcon {
    height: 20px;
    width: 20px;
  }

  .voteTitleText {
    font-size: 16px;
  }

  .pdfLink {
    gap: 8px;
    padding: 10px 40px;
    border-radius: 7px;
    font-size: 14px;
  }

  .voteDescriptionContainer {
    margin-top: 25px;
    font-size: 14px;
  }

  .voteDescriptionText {
    font-size: 14px;
  }

  .vote-button-wrapper {
    padding: 15px;
    margin: 6px 0;
    border-radius: 7px;
  }

  .vote-text {
    font-size: 16px;
  }

  .vote-percentage {
    font-size: 12px;
  }

  .voteActionContainer {
    gap: 16px;
  }

  .feedCardFooterText {
    font-size: 16px;
  }

  .feedsCommentInput {
    padding-top: 12px;
    padding-left: 12px;
    font-size: 12px;
  }

  .commentButton {
    padding: 6px;
  }

  .commentUserPhoto {
    width: 28px;
    height: 28px;
  }

  .commentUserName {
    font-size: 12px;
  }

  .commentTime {
    font-size: 11px;
  }

  .commentText {
    font-size: 13px;
  }

  .popupContent {
    padding: 13px;
    gap: 8px;
    border-radius: 18px;
  }

  .popupBtn {
    border-radius: 12px;
    width: 300px;
    height: 50px;
    padding: 15px;
    gap: 7px;
    font-size: 13px;
  }

  .informationBtnIcon {
    height: 22px;
    width: 22px;
  }

  .informationBtnText {
    font-size: 14px;
  }

  .reportBtnText {
    font-size: 14px;
  }

  .reportReasonOptions {
    gap: 8px;
    margin-top: 8px;
  }

  .reportReasonOption {
    font-size: 14px;
    border-radius: 12px;
    width: 260px;
    height: 8px;
    padding: 18px;
  }

  .pausedContainer {
    padding: 3px 7px;
    border-radius: 4px;
  }

  .pausedtext {
    font-size: 10px;
  }
}

@media (max-width: 1280px) {
  .profilePic {
    height: 35px;
    width: 35px;
  }

  .profileNameText {
    font-size: 13px;
  }

  .timeText {
    font-size: 13px;
  }

  .infoIcon {
    height: 18px;
    width: 18px;
  }

  .voteTitleText {
    font-size: 14px;
  }

  .pdfLink {
    gap: 6px;
    padding: 8px 35px;
    border-radius: 6px;
    font-size: 12px;
  }

  .voteDescriptionContainer {
    margin-top: 15px;
    font-size: 13px;
  }

  .voteDescriptionText {
    font-size: 13px;
  }

  .vote-button-wrapper {
    padding: 12px;
    margin: 4px 0;
    border-radius: 6px;
  }

  .vote-text {
    font-size: 15px;
  }

  .vote-percentage {
    font-size: 12px;
  }

  .voteActionContainer {
    gap: 14px;
  }

  .feedCardFooterText {
    font-size: 14px;
  }

  .feedsCommentInput {
    padding-top: 10px;
    padding-left: 10px;
    font-size: 10px;
  }

  .commentButton {
    padding: 5px;
  }

  .commentUserPhoto {
    width: 25px;
    height: 25px;
  }

  .commentUserName {
    font-size: 11px;
  }

  .commentTime {
    font-size: 10px;
  }

  .commentText {
    font-size: 11px;
  }

  .popupContent {
    padding: 12px;
    gap: 7px;
    border-radius: 18px;
  }

  .popupBtn {
    border-radius: 12px;
    width: 280px;
    height: 48px;
    padding: 15px;
    gap: 6px;
    font-size: 12px;
  }

  .informationBtnIcon {
    height: 20px;
    width: 20px;
  }

  .informationBtnText {
    font-size: 13px;
  }

  .reportBtnText {
    font-size: 13px;
  }

  .reportReasonOptions {
    gap: 7px;
    margin-top: 7px;
  }

  .reportReasonOption {
    font-size: 13px;
    border-radius: 10px;
    width: 240px;
    height: 8px;
    padding: 18px;
  }

  .pausedContainer {
    padding: 3px 7px;
    border-radius: 4px;
  }

  .pausedtext {
    font-size: 10px;
  }
}

@media (max-width: 1024px) {
  .profilePic {
    height: 30px;
    width: 30px;
  }

  .profileNameText {
    font-size: 10px;
  }

  .timeText {
    font-size: 10px;
  }

  .infoIcon {
    height: 18px;
    width: 18px;
  }

  .voteTitleText {
    font-size: 12px;
  }

  .pdfLink {
    gap: 6px;
    padding: 8px 35px;
    border-radius: 6px;
    font-size: 12px;
  }

  .voteDescriptionContainer {
    margin-top: 10px;
    font-size: 12px;
  }

  .voteDescriptionText {
    font-size: 12px;
  }

  .vote-button-wrapper {
    padding: 12px;
    margin: 4px 0;
    border-radius: 6px;
  }

  .vote-text {
    font-size: 12px;
  }

  .vote-percentage {
    font-size: 10px;
  }

  .voteActionContainer {
    gap: 12px;
  }

  .feedCardFooterText {
    font-size: 12px;
  }

  .feedsCommentInput {
    padding-top: 8px;
    padding-left: 8px;
    font-size: 10px;
  }

  .commentButton {
    padding: 4px;
  }

  .commentUserPhoto {
    width: 25px;
    height: 25px;
  }

  .commentUserName {
    font-size: 10px;
  }

  .commentTime {
    font-size: 9px;
  }

  .commentText {
    font-size: 10px;
  }

  .popupContent {
    padding: 12px;
    gap: 7px;
    border-radius: 18px;
  }

  .popupBtn {
    border-radius: 12px;
    width: 260px;
    height: 48px;
    padding: 15px;
    gap: 5px;
    font-size: 12px;
  }

  .informationBtnIcon {
    height: 18px;
    width: 18px;
  }

  .informationBtnText {
    font-size: 12px;
  }

  .reportBtnText {
    font-size: 12px;
  }

  .reportReasonOptions {
    gap: 6px;
    margin-top: 6px;
  }

  .reportReasonOption {
    font-size: 12px;
    border-radius: 10px;
    width: 220px;
    padding: 16px;
  }

  .pausedContainer {
    padding: 3px 7px;
    border-radius: 4px;
  }

  .pausedtext {
    font-size: 10px;
  }
}

/* View Sub-Ballot Button */
.view-sub-ballot-btn {
  position: absolute;
  bottom: 8px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(76, 175, 80, 0.15);
  border: 1px solid rgba(76, 175, 80, 0.4);
  border-radius: 8px;
  color: #4caf50;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
}

.view-sub-ballot-btn:hover {
  background: rgba(76, 175, 80, 0.25);
  border-color: #4caf50;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.view-sub-ballot-btn:active {
  transform: translateY(0);
}

.view-sub-ballot-btn svg {
  transition: transform 0.3s ease;
}

.view-sub-ballot-btn:hover svg {
  transform: translateX(2px);
}

@media (max-width: 768px) {
  .view-sub-ballot-btn {
    font-size: 11px;
    padding: 5px 10px;
    bottom: 6px;
    right: 10px;
  }

  .view-sub-ballot-btn svg {
    width: 12px;
    height: 12px;
  }
}

/* View Sub-Ballot Button Main (Below Options) */
.view-sub-ballot-container {
  display: flex;
  justify-content: flex-end;
  /* Aligns to right */
  margin-top: 12px;
  padding-right: 4px;
}

.view-sub-ballot-btn-main {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: transparent;
  border: none;
  color: #3BB3AE;
  /* Project Theme Teal */
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 8px;
}

.view-sub-ballot-btn-main:hover {
  background: rgba(59, 179, 174, 0.1);
  /* Theme color with opacity */
  transform: translateX(4px);
  text-shadow: 0 0 15px rgba(59, 179, 174, 0.4);
}

.view-sub-ballot-btn-main svg {
  transition: transform 0.2s ease;
}

.view-sub-ballot-btn-main:hover svg {
  transform: translateX(2px);
}

/* Hide old button if it exists */
.view-sub-ballot-btn {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/Components/Feeds/Feeds.css"],"names":[],"mappings":"AAGA;EACE;;;;;eAKa;AACf;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,OAAO;IACP,WAAW;IACX,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;;gBAGc;AAChB;;AAEA;;GAEG;;AAEH;EACE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA,gDAAgD;AAChD;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;EACE,aAAa;AACf","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n\n.Feeds {\n  /* width: 55%;\n  color: white;\n  padding-top: 15vh;\n  margin-left: 22%;\n  position: relative;\n  z-index: 1; */\n}\n\n/* Ballot Search & Political Affiliation Filter Bar */\n.ballotSearchBarContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  background: #142222;\n  border-radius: 12px;\n  border: 1px solid #233737;\n  margin: 12px 0 6px 0;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.ballotSearchInputWrap {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  background: #0e1b1b;\n  border: 1px solid #2a3d3d;\n  border-radius: 20px;\n  padding: 6px 14px;\n  gap: 8px;\n  transition: all 0.2s ease;\n}\n\n.ballotSearchInputWrap:focus-within {\n  border-color: #5aaf9a;\n  box-shadow: 0 0 0 2px rgba(90, 175, 154, 0.2);\n}\n\n.ballotSearchInputField {\n  flex: 1;\n  background: transparent;\n  border: none;\n  outline: none;\n  color: #ffffff;\n  font-size: 14px;\n  font-family: inherit;\n}\n\n.ballotSearchInputField::placeholder {\n  color: #728a8a;\n  font-size: 13.5px;\n}\n\n.ballotClearSearchBtn {\n  background: transparent;\n  border: none;\n  color: #728a8a;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: 2px;\n  border-radius: 50%;\n  transition: color 0.15s ease;\n}\n\n.ballotClearSearchBtn:hover {\n  color: #ffffff;\n}\n\n.ballotSearchResultsInfo {\n  padding: 4px 16px 8px 16px;\n  color: #8fa8a8;\n  font-size: 13px;\n}\n\n.ballotSearchResultsInfo strong {\n  color: #5aaf9a;\n}\n\n@media (max-width: 768px) {\n  .ballotSearchBarContainer {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n    padding: 10px 12px;\n  }\n\n  .ballotPartyFilterBtn {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .ballotPartyDropdownMenu {\n    left: 0;\n    right: auto;\n    width: 100%;\n  }\n\n  .partyBtnLabel {\n    max-width: none;\n  }\n}\n\n.feedsContainer {\n  /* display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  width: 100%; */\n}\n\n/* .feedCardContainer {\n  width: 85%;\n} */\n\n.feedCard {\n  background-color: #0e1b1b;\n  display: flex;\n  justify-content: center;\n  border-radius: 20px;\n  margin-top: 2vh;\n  transform: 0.3s;\n}\n\n.feedBody {\n  width: 90%;\n  box-sizing: border-box;\n  padding-top: 2vh;\n  padding-bottom: 2vh;\n}\n\n.feedCardHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.profileDetailsContainer {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 0.5vw;\n}\n\n.profilePic {\n  height: 50px;\n  width: 50px;\n  border-radius: 50px;\n}\n\n.profileDetails {\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n}\n\n.profileNameText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  /* Add text wrapping properties */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n\n.timeContainer {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 0.8vw;\n}\n\n.timeText {\n  color: var(--Grey, #777);\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.infoIcon {\n  height: 24px;\n  width: 24px;\n  cursor: pointer;\n}\n\n.infoIcon:hover {\n  transform: scale(1.1);\n  transition: all 0.3s ease;\n}\n\n.feedCardVoteTitleContainer {\n  margin-top: 1.2vh;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.voteTitleText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-top: 10px;\n  /* Add text wrapping properties */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n\n\n.voteMediaContainer {\n  margin-top: 30px;\n  height: 60vh;\n  background-color: #070F0F;\n  border-radius: 15px;\n}\n\n.voteMedia {\n  height: 100%;\n  width: 100%;\n  border-radius: 12px;\n  object-fit: contain;\n}\n\n.voteDescriptionContainer {\n  margin-top: 30px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  color: #777;\n  /* Add text wrapping properties */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n\n.voteDescriptionText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  color: #777;\n  /* Add text wrapping properties */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: pre-wrap;\n  display: block;\n  width: 100%;\n}\n\n.voteBtnsContainer {\n  display: flex;\n  margin-top: 20px;\n  flex-direction: column;\n  width: 100%;\n  gap: 10px;\n}\n\n.voteBtn {\n  all: unset;\n  border-radius: 12px;\n  border: 1px solid #484848;\n  box-sizing: border-box;\n  padding-top: 2vh;\n  padding-bottom: 2vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-family: \"Inter\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.voteBtncoloured {\n  all: unset;\n  border-radius: 12px;\n  border: 1px solid #484848;\n  box-sizing: border-box;\n  padding-top: 2vh;\n  padding-bottom: 2vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-family: \"Inter\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  background-color: #3BB3AE;\n}\n\n.voteDetailsContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  padding-left: 20px;\n  padding-right: 20px;\n  margin-top: 2vh;\n}\n\n.voteActionContainer {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 18px;\n}\n\n.voteActionContainer2 {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.feedCardFooterText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.feedCardFooterIcon {\n  height: 28px;\n  width: 28px;\n}\n\n.like-icon:hover {\n  transform: scale(1.2);\n  transition: all 0.3s ease;\n}\n\n.pdfContainer {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #070F0F;\n  border-radius: 8px;\n  overflow: hidden;\n  min-height: 400px;\n}\n\n.pdf-loading,\n.pdf-error {\n  color: white;\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  padding: 20px;\n  text-align: center;\n}\n\n.pdf-error {\n  color: #ff6b6b;\n}\n\n.pdfContainer .react-pdf__Document {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.pdfContainer .react-pdf__Page {\n  max-width: 100%;\n  height: auto;\n}\n\n.pdfLinkContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  border-radius: 12px;\n}\n\n.pdfLink {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 50px;\n  background: #48D1CC;\n  color: #070F0F;\n  text-decoration: none;\n  border-radius: 8px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.pdfLink:hover {\n  background: #3BB3AE;\n  transform: translateY(-2px);\n}\n\n.pdfIcon {\n  width: 24px;\n  height: 24px;\n}\n\n.vote-button-wrapper {\n  position: relative;\n  width: 100%;\n  padding: 20px 20px;\n  margin: 8px 0;\n  border: 0.2px solid #484848;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 1;\n}\n\n.vote-button-wrapper:disabled {\n  cursor: default;\n  opacity: 0.9;\n}\n\n.vote-button-wrapper:not(:disabled):hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.vote-progress-bar {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  background: #3BB3AE;\n  transition: width 0.6s ease-in-out;\n  z-index: 1;\n  width: 0;\n}\n\n.vote-text {\n  position: relative;\n  z-index: 2;\n  font-family: Inter;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  color: white;\n  /* Add text wrapping properties */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: pre-wrap;\n  text-align: left;\n}\n\n.vote-text.voted {\n  color: #777;\n}\n\n.vote-percentage.voted {\n  color: #777;\n}\n\n.vote-percentage {\n  position: relative;\n  z-index: 2;\n  font-size: 14px;\n  font-weight: 600;\n  color: white;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.voted .vote-percentage {\n  opacity: 1;\n}\n\n.voted .vote-progress-bar {\n  background-color: #3BB3AE;\n}\n\n.voted.selected .vote-progress-bar {\n  background-color: #3BB3AE;\n  opacity: 1;\n  animation: progressFill 0.8s ease-out;\n}\n\n@keyframes progressFill {\n  from {\n    width: 0;\n  }\n\n  to {\n    width: 100%;\n  }\n}\n\n.vote-button-wrapper:hover .vote-percentage {\n  opacity: 1;\n}\n\n/* Remove previous button styles if they exist */\n.voteBtn,\n.voteBtncoloured {\n  display: none;\n}\n\n.commentContainer {\n  margin-top: 20px;\n  padding: 15px;\n  border-top: 1px solid #484848;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.commentInputContainer {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  background: transparent;\n  border-radius: 8px;\n  height: 17vh;\n}\n\n.feedsCommentInput {\n  all: unset;\n  width: 100%;\n  height: 100%;\n  background: #070F0F;\n  border: 1px solid #484848;\n  border-radius: 8px;\n  padding-top: 15px;\n  padding-left: 15px;\n  padding-right: 6.5vw;\n  color: white;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  resize: none;\n  outline: none;\n  box-sizing: border-box;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n\n.commentInput:focus {\n  border-color: #3BB3AE;\n}\n\n.filePreviewContainer {\n  position: relative;\n  width: 100%;\n  height: 90%;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #070F0F;\n  border: 1px solid #484848;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 15px;\n  padding-bottom: 15px;\n  z-index: 1;\n}\n\n.filePreview {\n  max-width: 100%;\n  max-height: 90%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  background: rgba(255, 255, 255, 0.10);\n  padding: 15px 30px;\n  border-radius: 12px;\n}\n\n.commentButtonContainer {\n  position: absolute;\n  right: 2%;\n  top: 10%;\n  display: flex;\n  gap: 5px;\n  z-index: 2000;\n}\n\n.commentButton {\n  background: #3BB3AE;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  z-index: 2000;\n}\n\n.commentButton:hover {\n  background: #48D1CC;\n  transform: translateY(-2px);\n}\n\n.clearFileBtn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  transition: background-color 0.2s;\n}\n\n.clearFileBtn:hover {\n  background: rgba(0, 0, 0, 0.9);\n}\n\n.existingCommentsContainer {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.commentItem {\n  display: flex;\n  /* flex-direction: row; */\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  padding: 10px;\n  border-radius: 8px;\n  /* background: #070F0F; */\n  border: 1px solid #484848;\n  height: auto;\n}\n\n.commentItemContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.commentHeader {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.commentUserPhoto {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.commentUserInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.commentUserName {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: white;\n  /* Add text wrapping properties */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n\n.commentTime {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  color: #777;\n}\n\n.commentText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 18px;\n  color: white;\n  line-height: 1.4;\n  padding-left: 42px;\n  /* Add text wrapping properties */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n\n.popupOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n}\n\n.popupContent {\n  position: absolute;\n  background-color: #071414;\n  padding: 15px;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.popupBtn {\n  border: 1px solid #484848;\n  border-radius: 12px;\n  cursor: pointer;\n  font-weight: 500;\n  font-family: \"Inter\", sans-serif;\n  width: 100%;\n  display: flex;\n  width: 349.407px;\n  height: 57px;\n  padding: 20px;\n  justify-content: start;\n  gap: 10px;\n  color: #FFF;\n  font-size: 15px;\n  font-style: normal;\n  background-color: #071414;\n  align-items: center;\n}\n\n.popupTitle {\n  color: #FFF;\n  text-overflow: ellipsis;\n  font-family: Inter;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.commentVideo {\n  width: 100%;\n  height: 20vh;\n  object-fit: contain;\n  border-radius: 12px;\n}\n\n.saveBtn:hover {\n  background-color: #484848;\n}\n\n\n.reportBtn:hover {\n  background-color: #484848;\n}\n\n.deleteCommentBtn {\n  background-color: transparent;\n  border: none;\n}\n\n.shareButtonsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px 0;\n}\n\n.voteShareContainer {\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n.voteShareContainer:hover {\n  transform: scale(1.1);\n}\n\n.informationBtnIcon {\n  height: 24px;\n  width: 24px;\n}\n\n.informationBtnText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n}\n\n.reportBtnText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  color: #C15F5F;\n}\n\n.reportReasonContainer {\n  margin-top: 10px;\n}\n\n.reportReasonOptions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.reportReasonOption {\n  border: 1px solid #484848;\n  border-radius: 12px;\n  cursor: pointer;\n  font-weight: 500;\n  font-family: \"Inter\", sans-serif;\n  width: 100%;\n  display: flex;\n  width: 310px;\n  height: 10px;\n  padding: 20px;\n  justify-content: start;\n  gap: 10px;\n  color: #FFF;\n  font-size: 15px;\n  font-style: normal;\n  background-color: #071414;\n  display: flex;\n  align-items: center;\n}\n\n.reportReasonOption:hover {\n  background-color: #484848;\n}\n\n.pausedContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px 10px;\n  border-radius: 5px;\n  background-color: #484848;\n}\n\n.pausedtext {\n  color: #5AAF9A;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n@media (max-width: 1640px) {\n  .profilePic {\n    height: 45px;\n    width: 45px;\n  }\n\n  .profileNameText {\n    font-size: 15px;\n  }\n\n  .timeText {\n    font-size: 15px;\n  }\n\n  .infoIcon {\n    height: 22px;\n    width: 22px;\n  }\n\n  .voteTitleText {\n    font-size: 18px;\n  }\n\n  .pdfLink {\n    gap: 10px;\n    padding: 12px 45px;\n    border-radius: 8px;\n    font-size: 16px;\n  }\n\n  .voteDescriptionContainer {\n    margin-top: 30px;\n    font-size: 16px;\n  }\n\n  .voteDescriptionText {\n    font-size: 16px;\n  }\n\n  .vote-button-wrapper {\n    padding: 18px;\n    margin: 8px 0;\n    border-radius: 8px;\n  }\n\n  .vote-text {\n    font-size: 18px;\n  }\n\n  .vote-percentage {\n    font-size: 14px;\n  }\n\n  .voteActionContainer {\n    gap: 16px;\n  }\n\n  .feedCardFooterText {\n    font-size: 18px;\n  }\n\n  .feedsCommentInput {\n    padding-top: 14px;\n    padding-left: 14px;\n    font-size: 14px;\n  }\n\n  .commentButton {\n    padding: 7px;\n  }\n\n  .commentUserPhoto {\n    width: 30px;\n    height: 30px;\n  }\n\n  .commentUserName {\n    font-size: 13px;\n  }\n\n  .commentTime {\n    font-size: 12px;\n  }\n\n  .commentText {\n    font-size: 14px;\n  }\n\n  .popupContent {\n    padding: 14px;\n    gap: 9px;\n    border-radius: 20px;\n  }\n\n  .popupBtn {\n    border-radius: 12px;\n    width: 320px;\n    height: 54px;\n    padding: 18px;\n    gap: 8px;\n    font-size: 14px;\n  }\n\n  .informationBtnIcon {\n    height: 22px;\n    width: 22px;\n  }\n\n  .informationBtnText {\n    font-size: 15px;\n  }\n\n  .reportBtnText {\n    font-size: 15px;\n  }\n\n  .reportReasonOptions {\n    gap: 9px;\n    margin-top: 9px;\n  }\n\n  .reportReasonOption {\n    font-size: 15px;\n    border-radius: 12px;\n    width: 300px;\n    height: 8px;\n    padding: 18px;\n  }\n\n  .pausedContainer {\n    padding: 4px 9px;\n    border-radius: 5px;\n  }\n\n  .pausedtext {\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 1440px) {\n  .profilePic {\n    height: 40px;\n    width: 40px;\n  }\n\n  .profileNameText {\n    font-size: 14px;\n  }\n\n  .timeText {\n    font-size: 14px;\n  }\n\n  .infoIcon {\n    height: 20px;\n    width: 20px;\n  }\n\n  .voteTitleText {\n    font-size: 16px;\n  }\n\n  .pdfLink {\n    gap: 8px;\n    padding: 10px 40px;\n    border-radius: 7px;\n    font-size: 14px;\n  }\n\n  .voteDescriptionContainer {\n    margin-top: 25px;\n    font-size: 14px;\n  }\n\n  .voteDescriptionText {\n    font-size: 14px;\n  }\n\n  .vote-button-wrapper {\n    padding: 15px;\n    margin: 6px 0;\n    border-radius: 7px;\n  }\n\n  .vote-text {\n    font-size: 16px;\n  }\n\n  .vote-percentage {\n    font-size: 12px;\n  }\n\n  .voteActionContainer {\n    gap: 16px;\n  }\n\n  .feedCardFooterText {\n    font-size: 16px;\n  }\n\n  .feedsCommentInput {\n    padding-top: 12px;\n    padding-left: 12px;\n    font-size: 12px;\n  }\n\n  .commentButton {\n    padding: 6px;\n  }\n\n  .commentUserPhoto {\n    width: 28px;\n    height: 28px;\n  }\n\n  .commentUserName {\n    font-size: 12px;\n  }\n\n  .commentTime {\n    font-size: 11px;\n  }\n\n  .commentText {\n    font-size: 13px;\n  }\n\n  .popupContent {\n    padding: 13px;\n    gap: 8px;\n    border-radius: 18px;\n  }\n\n  .popupBtn {\n    border-radius: 12px;\n    width: 300px;\n    height: 50px;\n    padding: 15px;\n    gap: 7px;\n    font-size: 13px;\n  }\n\n  .informationBtnIcon {\n    height: 22px;\n    width: 22px;\n  }\n\n  .informationBtnText {\n    font-size: 14px;\n  }\n\n  .reportBtnText {\n    font-size: 14px;\n  }\n\n  .reportReasonOptions {\n    gap: 8px;\n    margin-top: 8px;\n  }\n\n  .reportReasonOption {\n    font-size: 14px;\n    border-radius: 12px;\n    width: 260px;\n    height: 8px;\n    padding: 18px;\n  }\n\n  .pausedContainer {\n    padding: 3px 7px;\n    border-radius: 4px;\n  }\n\n  .pausedtext {\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 1280px) {\n  .profilePic {\n    height: 35px;\n    width: 35px;\n  }\n\n  .profileNameText {\n    font-size: 13px;\n  }\n\n  .timeText {\n    font-size: 13px;\n  }\n\n  .infoIcon {\n    height: 18px;\n    width: 18px;\n  }\n\n  .voteTitleText {\n    font-size: 14px;\n  }\n\n  .pdfLink {\n    gap: 6px;\n    padding: 8px 35px;\n    border-radius: 6px;\n    font-size: 12px;\n  }\n\n  .voteDescriptionContainer {\n    margin-top: 15px;\n    font-size: 13px;\n  }\n\n  .voteDescriptionText {\n    font-size: 13px;\n  }\n\n  .vote-button-wrapper {\n    padding: 12px;\n    margin: 4px 0;\n    border-radius: 6px;\n  }\n\n  .vote-text {\n    font-size: 15px;\n  }\n\n  .vote-percentage {\n    font-size: 12px;\n  }\n\n  .voteActionContainer {\n    gap: 14px;\n  }\n\n  .feedCardFooterText {\n    font-size: 14px;\n  }\n\n  .feedsCommentInput {\n    padding-top: 10px;\n    padding-left: 10px;\n    font-size: 10px;\n  }\n\n  .commentButton {\n    padding: 5px;\n  }\n\n  .commentUserPhoto {\n    width: 25px;\n    height: 25px;\n  }\n\n  .commentUserName {\n    font-size: 11px;\n  }\n\n  .commentTime {\n    font-size: 10px;\n  }\n\n  .commentText {\n    font-size: 11px;\n  }\n\n  .popupContent {\n    padding: 12px;\n    gap: 7px;\n    border-radius: 18px;\n  }\n\n  .popupBtn {\n    border-radius: 12px;\n    width: 280px;\n    height: 48px;\n    padding: 15px;\n    gap: 6px;\n    font-size: 12px;\n  }\n\n  .informationBtnIcon {\n    height: 20px;\n    width: 20px;\n  }\n\n  .informationBtnText {\n    font-size: 13px;\n  }\n\n  .reportBtnText {\n    font-size: 13px;\n  }\n\n  .reportReasonOptions {\n    gap: 7px;\n    margin-top: 7px;\n  }\n\n  .reportReasonOption {\n    font-size: 13px;\n    border-radius: 10px;\n    width: 240px;\n    height: 8px;\n    padding: 18px;\n  }\n\n  .pausedContainer {\n    padding: 3px 7px;\n    border-radius: 4px;\n  }\n\n  .pausedtext {\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .profilePic {\n    height: 30px;\n    width: 30px;\n  }\n\n  .profileNameText {\n    font-size: 10px;\n  }\n\n  .timeText {\n    font-size: 10px;\n  }\n\n  .infoIcon {\n    height: 18px;\n    width: 18px;\n  }\n\n  .voteTitleText {\n    font-size: 12px;\n  }\n\n  .pdfLink {\n    gap: 6px;\n    padding: 8px 35px;\n    border-radius: 6px;\n    font-size: 12px;\n  }\n\n  .voteDescriptionContainer {\n    margin-top: 10px;\n    font-size: 12px;\n  }\n\n  .voteDescriptionText {\n    font-size: 12px;\n  }\n\n  .vote-button-wrapper {\n    padding: 12px;\n    margin: 4px 0;\n    border-radius: 6px;\n  }\n\n  .vote-text {\n    font-size: 12px;\n  }\n\n  .vote-percentage {\n    font-size: 10px;\n  }\n\n  .voteActionContainer {\n    gap: 12px;\n  }\n\n  .feedCardFooterText {\n    font-size: 12px;\n  }\n\n  .feedsCommentInput {\n    padding-top: 8px;\n    padding-left: 8px;\n    font-size: 10px;\n  }\n\n  .commentButton {\n    padding: 4px;\n  }\n\n  .commentUserPhoto {\n    width: 25px;\n    height: 25px;\n  }\n\n  .commentUserName {\n    font-size: 10px;\n  }\n\n  .commentTime {\n    font-size: 9px;\n  }\n\n  .commentText {\n    font-size: 10px;\n  }\n\n  .popupContent {\n    padding: 12px;\n    gap: 7px;\n    border-radius: 18px;\n  }\n\n  .popupBtn {\n    border-radius: 12px;\n    width: 260px;\n    height: 48px;\n    padding: 15px;\n    gap: 5px;\n    font-size: 12px;\n  }\n\n  .informationBtnIcon {\n    height: 18px;\n    width: 18px;\n  }\n\n  .informationBtnText {\n    font-size: 12px;\n  }\n\n  .reportBtnText {\n    font-size: 12px;\n  }\n\n  .reportReasonOptions {\n    gap: 6px;\n    margin-top: 6px;\n  }\n\n  .reportReasonOption {\n    font-size: 12px;\n    border-radius: 10px;\n    width: 220px;\n    padding: 16px;\n  }\n\n  .pausedContainer {\n    padding: 3px 7px;\n    border-radius: 4px;\n  }\n\n  .pausedtext {\n    font-size: 10px;\n  }\n}\n\n/* View Sub-Ballot Button */\n.view-sub-ballot-btn {\n  position: absolute;\n  bottom: 8px;\n  right: 12px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: rgba(76, 175, 80, 0.15);\n  border: 1px solid rgba(76, 175, 80, 0.4);\n  border-radius: 8px;\n  color: #4caf50;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 10;\n}\n\n.view-sub-ballot-btn:hover {\n  background: rgba(76, 175, 80, 0.25);\n  border-color: #4caf50;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);\n}\n\n.view-sub-ballot-btn:active {\n  transform: translateY(0);\n}\n\n.view-sub-ballot-btn svg {\n  transition: transform 0.3s ease;\n}\n\n.view-sub-ballot-btn:hover svg {\n  transform: translateX(2px);\n}\n\n@media (max-width: 768px) {\n  .view-sub-ballot-btn {\n    font-size: 11px;\n    padding: 5px 10px;\n    bottom: 6px;\n    right: 10px;\n  }\n\n  .view-sub-ballot-btn svg {\n    width: 12px;\n    height: 12px;\n  }\n}\n\n/* View Sub-Ballot Button Main (Below Options) */\n.view-sub-ballot-container {\n  display: flex;\n  justify-content: flex-end;\n  /* Aligns to right */\n  margin-top: 12px;\n  padding-right: 4px;\n}\n\n.view-sub-ballot-btn-main {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: transparent;\n  border: none;\n  color: #3BB3AE;\n  /* Project Theme Teal */\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-radius: 8px;\n}\n\n.view-sub-ballot-btn-main:hover {\n  background: rgba(59, 179, 174, 0.1);\n  /* Theme color with opacity */\n  transform: translateX(4px);\n  text-shadow: 0 0 15px rgba(59, 179, 174, 0.4);\n}\n\n.view-sub-ballot-btn-main svg {\n  transition: transform 0.2s ease;\n}\n\n.view-sub-ballot-btn-main:hover svg {\n  transform: translateX(2px);\n}\n\n/* Hide old button if it exists */\n.view-sub-ballot-btn {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
